import Page from 'src/components/molecules/page';
import { FC } from 'react';
import { FormSettingList } from 'src/components/organisms/reservation-form-setting/list';
import HeadLineText from 'src/components/atoms/head-line-text';
import { Stack } from '@mui/material';

export const ReservationFormSettingListPage: FC = () => {
  /* 定数宣言 */
  const title = '予約フォーム設定';

  return (
    <Page title={title}>
      <FormSettingList />
    </Page>
  );
};
